import React from 'react';

/**
 * Outer wrapper shared by every page: grey canvas, responsive gutters and a
 * centred content column.
 */
export default function PageShell({ children, className = '' }) {
    return (
        <div className={`min-h-full bg-[#f4f6f9] p-2.5 sm:p-3 md:p-5 font-[Inter,system-ui,sans-serif] ${className}`}>
            <div className="max-w-[1600px] mx-auto flex flex-col gap-2.5 md:gap-4">{children}</div>
        </div>
    );
}
